import { render, staticRenderFns } from "./card-actions.vue?vue&type=template&id=493a0a99&scoped=true"
import script from "./card-actions.vue?vue&type=script&lang=js"
export * from "./card-actions.vue?vue&type=script&lang=js"
import style0 from "./card-actions.vue?vue&type=style&index=0&id=493a0a99&prod&lang=css"
import style1 from "./card-actions.vue?vue&type=style&index=1&id=493a0a99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493a0a99",
  null
  
)

export default component.exports